module.exports = __webpack_public_path__ + "images/235e36e3d8b88937a0a5f3cb59fb8c4a.svg";